export function formatCurrency(currency: number | string) {
  return new Intl.NumberFormat("fr-CA", {
    style: "currency",
    currency: "CAD",
    /* minimumFractionDigits: 0, */
  })
    .format(currency as any)
    .replaceAll(",", ".")
}
